import "../../App.css";
import Api from "../api/api";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import showToast from "../util/toast";
import CodeForm from "../CodeForm/CodeForm";

const EditCode = () => {
  const location = useLocation();
  const history = useHistory();

  const onSubmit = (params) => {
    Api.editCode({
      params,
      onError: (error) => {
        showToast("error", JSON.stringify(error));
      },
      onSuccess: () => {
        showToast("success", "Code is successfully edited");
        history.goBack();
      },
    });
  };

  return <CodeForm onSubmit={onSubmit} data={location.params.data} editMode />;
};

export default EditCode;
